import { render, staticRenderFns } from "./purchase-status-navigation.vue?vue&type=template&id=bd9d29a8&"
import script from "./purchase-status-navigation.vue?vue&type=script&lang=js&"
export * from "./purchase-status-navigation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports